<template>
  <div class="wrapper mx-auto">
    <div class="ui-card ui-tool card-shadow mt-5">
      <div class="row">
        <div class="col">
          <div class="ui-heading">图片隐私水印</div>
        </div>
      </div>

      <div class="mb-3">
        <input type="file" accept="image/*" class="d-none" ref="inputEl" @change="onPreview">
        <button class="btn btn-primary w-100" @click="onFileSelect">选择文件</button>
      </div>

      <div class="mb-3 row gx-2">
        <div class="col">
          <label for="watermark-text" class="form-label"><strong>水印文字</strong></label>
          <input type="text" class="form-control" id="watermark-text" v-model="state.text">
        </div>
        <div class="col">
          <label for="watermark-color" class="form-label"><strong>水印颜色</strong></label>
          <input type="text" class="form-control colorpicker-input" id="watermark-color" v-model="state.color"
                 @focusin="state.showColorPicker = true">
          <ColorPicker v-model="state.color" v-show="state.showColorPicker"
                       @click="state.showColorPicker = false"></ColorPicker>
        </div>
        <div class="col">
          <label for="watermark-opacity" class="form-label"><strong>水印透明度</strong></label>
          <input type="range" id="watermark-opacity" v-model="state.opacity">
        </div>
      </div>

      <div class="mb-3 row gx-2">
        <div class="col">
          <label for="watermark-fontsize" class="form-label"><strong>字体大小</strong></label>
          <input type="range" id="watermark-fontsize" v-model="state.fontSize">
        </div>
        <div class="col">
          <label for="watermark-width" class="form-label"><strong>水印横间隔</strong></label>
          <input type="range" id="watermark-width" v-model="state.width">
        </div>
        <div class="col">
          <label for="watermark-height" class="form-label"><strong>水印纵间隔</strong></label>
          <input type="range" id="watermark-height" v-model="state.height">
        </div>
      </div>
    </div>

    <div class="ui-card card-shadow p-0 mt-4" v-show="config.fullHeight > 0">
      <div class="d-flex border-bottom p-3">
        <button class="btn btn-outline-primary ms-auto" @click="onOpen">新窗口打开</button>
        <button class="btn btn-outline-primary ms-2" @click="onSave">下载图片</button>
      </div>
      <div class="p-3">
        <canvas ref="canvasEl" class="w-100"></canvas>
      </div>
    </div>

    <div class="ui-card card-shadow mt-4">
      <strong>使用全前端页面为图片添加水印。</strong>例如，在各种证件照上添加“仅用于办理XXXX，他用无效”水印，可防止证件照被他人盗用。
      本工具为JavaScript编写，运行于浏览器中，不会上传任何图片到服务端，请放心使用。
    </div>
  </div>
</template>

<script setup lang="js">
import {reactive, ref, computed, watch} from "vue";
import ColorPicker from "./components/ColorPicker.vue";

const state = reactive({
  img: new Image(),
  color: '#555555',
  showColorPicker: false,
  text: '2023年7月用于办理民宿入住，他用无效',
  opacity: '40',
  fontSize: '50',
  width: '0',
  height: '0',
});
const config = reactive({
  degree: 20,
  fontWidth: 0,
  fontSize: 0,
  font: '',
  cwWidth: 0,
  cwHeight: 0,
  fullWidth: 0,
  fullHeight: 0,
  fillStyle: '',
})

const inputEl = ref(null);
const canvasEl = ref(null)

const onFileSelect = () => {
  inputEl.value.click()
}

const onSave = e => {
  const imgData = canvasEl.value.toDataURL('image/png')
  const aLink = document.createElement("a");
  aLink.download = "download.png";
  aLink.href = imgData;
  aLink.click();
}

const onOpen = e => {
  canvasEl.value.toBlob(blob => {
    const blobUrl = URL.createObjectURL(blob);
    window.open(blobUrl, '_blank')
  }, "image/png",)
}

const onPreview = e => {
  const file = e.target.files[0];
  const reader = new FileReader();

  reader.onloadend = function () {
    state.img.onload = function () {
      syncConfig();
      canvasEl.value.width = config.fullWidth;
      canvasEl.value.height = config.fullHeight;
      const ctx = canvasEl.value.getContext('2d');
      drawWatermark(ctx, state.text);
    }
    state.img.src = reader.result;
  }

  if (file) {
    reader.readAsDataURL(file);
  } else {
    state.data = ''
  }
}

function drawWatermark(ctx, text) {
  ctx.drawImage(state.img, 0, 0);
  // ctx.clearRect(0, 0, canvasEl.value.width, canvasEl.value.height);
  ctx.fillStyle = ctx.createPattern(createText(text), "repeat");
  ctx.fillRect(0, 0, config.fullWidth, config.fullHeight);
}

function createText(text) {
  const cw = document.createElement("canvas");
  const wctx = cw.getContext("2d");
  // cw.width = Math.sqrt(Math.pow(width(), 2) + Math.pow(height(), 2));
  cw.width = config.cwWidth
  cw.height = config.cwHeight
  wctx.font = config.font;
  wctx.fillStyle = config.fillStyle;

  wctx.translate(10, config.cwHeight);
  wctx.rotate(-config.degree * Math.PI / 180);
  wctx.fillText(text, 0, 0);
  return cw
}

function syncConfig() {
  config.fontSize = 12 + (parseInt(state.fontSize) / 100) * 30;
  config.fontWidth = state.text.length * config.fontSize;
  config.font = `${config.fontSize}px 黑体`;
  config.fullWidth = state.img.width
  config.fullHeight = state.img.height
  config.cwHeight = config.fontWidth * Math.sin(config.degree * Math.PI / 180) + config.fullHeight * (parseInt(state.height) / 100);
  config.cwWidth = config.fontWidth * Math.cos(config.degree * Math.PI / 180) + config.fullWidth * (parseInt(state.width) / 100);

  const {r, g, b} = hexToRgb(state.color);
  config.fillStyle = `rgba(${r}, ${g}, ${b}, ${state.opacity / 100})`
}

function hexToRgb(hex) {
    // 先将输入的hex代码标准化，去除可能存在的'#'，并转换为小写
    hex = hex.replace('#', '').toLowerCase();

    // 解析hex代码为r, g, b值
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);

    return {r, g, b}
}

watch(state, () => {
  syncConfig()
  const ctx = canvasEl.value.getContext('2d');
  drawWatermark(ctx, state.text);
})

document.addEventListener('click', e => {
  if (e.target.className.indexOf('colorpicker') < 0) {
    state.showColorPicker = false
  }
})
</script>

<style lang="scss" scoped>
.form-label {
  font-weight: bold;
}

.form-range {
  margin-top: 500px;
}

$range-color: #ffffff;
$range-height: 30px;
$thumb-color: #337ab7;

input[type=range] {
  width: 100%;
  margin: 0 0;
  background-color: transparent;
  -webkit-appearance: none;
  height: 0;
}

input[type=range]:focus {
  outline: none;
}

input[type=range]::-webkit-slider-runnable-track {
  background: $range-color;
  border-radius: 3.4px;
  width: 100%;
  height: $range-height;
  cursor: pointer;
  border: 0.1px solid #ced4da;
}

input[type=range]::-webkit-slider-thumb {
  margin-top: -1px;
  width: 16px;
  height: $range-height;
  background: $thumb-color;
  border-radius: 3px;
  cursor: pointer;
  -webkit-appearance: none;
}

input[type=range]:focus::-webkit-slider-runnable-track {
  background: $range-color;
}

input[type=range]::-moz-range-track {
  height: $range-height;
  background: $range-color;
  border: 0.1px solid #ced4da;
  border-radius: 3.4px;
  cursor: pointer;
}

input[type=range]::-moz-range-thumb {
  width: 16px;
  height: $range-height;
  background: $thumb-color;
  border-radius: 3px;
  cursor: pointer;
}
</style>